export const socialMediaEnvs = {
  google: process.env.REACT_APP_GG_APP_ID || "",
  apple: process.env.REACT_APP_APPLE_ID || "",
};
